module.exports = __webpack_public_path__ + "static/media/88.2c28a800.png";